import { section } from '@/api';

const actions = {
    UP: 'up',
    DOWN: 'down',
    DISABLE: 'hidden',
    RESTORE: 'restore',
    DELETE: 'deleted',
    ADD: 'add'
};
// Finds index of item with current attribute and value.
function findWithAttr(array, attr, value) {
    for (let i = 0; i < array.length; i++) {
        if (array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}
// Finds first Hidden Index in the section list.
function findFirstHiddenIndex(list) {
    let firstHiddenSectionIndex = list.length;
    for (let i = 0; i < list.length; i++) {
        if (list[i].hidden) {
            firstHiddenSectionIndex = i;
            break;
        }
    }
    return firstHiddenSectionIndex;
}
// Updates all priority in db after every event.
async function updateAllSectionPriority(sections, subdomain) {
    const updateList = [];
    sections.sort((a, b) => {
        return a.priority - b.priority;
    });
    for (let i = 0; i < sections.length; i++) {
        if (sections[i].organisation === subdomain && !sections[i].deleted) {
            updateList.push({ id: sections[i].id, priority: sections[i].priority });
        }
    }
    if (updateList.length > 0) {
        await section.updateSectionsPriority(updateList, subdomain);
    }
}

function swap(array, currentIndex, consecutiveIndex) {
    const updatedArray = array;
    const firstHiddenIndex = findFirstHiddenIndex(array);
    if (consecutiveIndex >= 0 && currentIndex >= 0
        && consecutiveIndex < firstHiddenIndex
        && currentIndex < array.length && consecutiveIndex < array.length) {
        const tmp = array[currentIndex];
        updatedArray[currentIndex] = array[consecutiveIndex];
        updatedArray[currentIndex].priority = currentIndex + 1;
        updatedArray[consecutiveIndex] = tmp;
        updatedArray[consecutiveIndex].priority = consecutiveIndex + 1;
    }
    return updatedArray;
}

async function sortingArray(sectionsArray, section, action, subdomain) {
    let sectionsUpdatedArray = sectionsArray;
    const index = findWithAttr(sectionsArray, 'id', section.id);

    switch (action) {
        case (actions.UP):
            sectionsUpdatedArray = swap(sectionsArray, index - 1, index);
            break;
        case (actions.DOWN):
            sectionsUpdatedArray = swap(sectionsArray, index, index + 1);
            break;
        case (actions.ADD):
            if (section.priority > sectionsArray.length + 1) {
                throw new Error('Specified position is incorrect');
            }

            sectionsUpdatedArray.splice(section.priority - 1, 0, section);
            for (let i = 0; i < sectionsUpdatedArray.length; i++) {
                sectionsUpdatedArray[i].priority = i + 1;
                sectionsUpdatedArray[i].isChange = true;
            }
            break;
        default:
            throw new Error('action is not implemented');
    }

    await updateAllSectionPriority(sectionsUpdatedArray, subdomain);
    return sectionsUpdatedArray;
}

export default {
    actions,
    sortingArray,
    updateAllSectionPriority,
    findFirstHiddenIndex,
};



// WEBPACK FOOTER //
// ./src/lib/sortArray.js